
  // Gallery thumb click
  document.querySelectorAll('.gal-thumb').forEach(t => t.addEventListener('click', () => {
    document.querySelectorAll('.gal-thumb').forEach(x => x.classList.remove('is-active'));
    t.classList.add('is-active');
    document.getElementById('galMain').src = t.dataset.src;
  }));

  // Gallery arrows
  const thumbs = () => Array.from(document.querySelectorAll('.gal-thumb'));
  const goRel = (d) => {
    const ts = thumbs();
    const i = ts.findIndex(x => x.classList.contains('is-active'));
    const next = ts[(i + d + ts.length) % ts.length];
    next.click();
  };
  document.querySelector('.gal-arrow.prev').addEventListener('click', () => goRel(-1));
  document.querySelector('.gal-arrow.next').addEventListener('click', () => goRel(1));

  // Plan + tier picker (independent state per card)
  const planCards = document.querySelectorAll('.plan-card');
  function updateCardSummary(card){
    const selTier = card.querySelector('.tier.is-selected') || card.querySelector('.tier');
    if (!selTier) return;
    const total = parseFloat(selTier.dataset.total);
    const pps = (parseFloat(selTier.dataset.price) / 30).toFixed(2);
    card.querySelector('[data-plan-price]').textContent = '$' + total.toFixed(2);
    card.querySelector('[data-plan-pps]').textContent = '$' + pps + '/Serving';
    const cadence = card.querySelector('[data-perk-cadence]');
    if (cadence){
      const packs = parseInt(selTier.dataset.packs, 10);
      const months = selTier.dataset.tier === '30' ? '1 Month' : selTier.dataset.tier === '60' ? '2 Months' : '3 Months';
      cadence.textContent = packs + ' Pack' + (packs > 1 ? 's' : '') + ' Auto-Shipped Every ' + months;
    }
  }
  planCards.forEach(card => {
    updateCardSummary(card);
    card.addEventListener('click', () => {
      planCards.forEach(x => x.classList.toggle('is-selected', x === card));
    });
    card.querySelectorAll('.tier').forEach(t => {
      t.addEventListener('click', (e) => {
        e.stopPropagation();
        if (!card.classList.contains('is-selected')){
          planCards.forEach(x => x.classList.toggle('is-selected', x === card));
        }
        card.querySelectorAll('.tier').forEach(x => x.classList.toggle('is-selected', x === t));
        updateCardSummary(card);
      });
    });
  });

  document.getElementById('atcBtn').addEventListener('click', () => {
    const variantId = '44052420755671';
    const activeCard = document.querySelector('.plan-card.is-selected');
    const tier = activeCard.querySelector('.tier.is-selected') || activeCard.querySelector('.tier');
    const qty = parseInt(tier.dataset.packs, 10);
    const tierKey = tier.dataset.tier;
    if (activeCard.dataset.plan === 'autoship'){
      const planIds = { 30: '4617470167', 60: '4617601239', 90: '4617732311' };
      window.location.href = '/cart/' + variantId + ':' + qty + ':' + planIds[tierKey];
    } else {
      const codes = { 30: 'SPECIALZ1B', 60: 'SPECIALZ2B', 90: 'SPECIALZ3B' };
      window.location.href = '/cart/' + variantId + ':' + qty + '?discount=' + (codes[tierKey] || '');
    }
  });
